/* import __COLOCATED_TEMPLATE__ from './project-details-collapsed-summary.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

class ProjectDetailsCollapsedSummary extends Component {
  @service session;

  get hasOfferBeenMade() {
    return this.args.application.price > 0;
  }

  get sellerTotalAmount() {
    return this.args.application.shPaymentLineItems.reduce((carry, lineItem) => {
      return carry + lineItem.amount;
    }, 0);
  }

  get buyerTotalAmount() {
    return this.args.application.shInvoiceLineItems.reduce((carry, lineItem) => {
      return carry + lineItem.amount;
    }, 0);
  }

  get postedByString() {
    const postedByName = this.session.currentUser.id === this.args.application.buyer.id
    ? 'You'
    : this.args.application.buyer.fullName;
    return `Posted by ${postedByName}`;
  }

  get followersString() {
    const followersLength = this.args.application.followers?.length;

    if (!this.session.currentUser.isBuyer) {
      return '';
    }

    if (!followersLength || followersLength < 1) {
      return '0 followers';
    }

    if (followersLength === 1) {
      return '1 follower';
    }

    return `${followersLength} followers`;
  }
}

export default ProjectDetailsCollapsedSummary;
